let _theme = void 0;
const _onThemeListeners = [];
const _isTheme = (theme) => {
  return _theme === theme;
};
const _setTheme = (theme) => {
  _theme = theme;
  _onThemeListeners.forEach((listener) => {
    listener(theme);
  });
};
function useTheming() {
  return {
    isTheme: _isTheme,
    setTheme: _setTheme,
    theme: _theme,
    onTheme
  };
}
function setupTheming(opt) {
  _setTheme(opt.theme);
  if (opt.onTheme) {
    onTheme(opt.onTheme);
  }
  if (opt.env === "development") {
    window.setTheme = _setTheme;
    window.isTheme = _isTheme;
  }
}
function onTheme(callback) {
  _onThemeListeners.push(callback);
}
export {
  setupTheming,
  useTheming
};
//# sourceMappingURL=theming.es.js.map
